import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

interface SpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

export const Spinner = ({ className, size = "md" }: SpinnerProps) => {
  return (
    <div className={cn("animate-spin rounded-full border-2 border-muted-foreground border-t-primary", sizeClasses[size], className)} />
  );
};

export const SpinnerWithText = ({ text = "Chargement...", className }: { text?: string; className?: string }) => {
  return (
    <div className={cn("flex items-center justify-center space-x-2", className)}>
      <Spinner />
      <span className="text-muted-foreground">{text}</span>
    </div>
  );
};
